/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
'use strict';
const mainConfig = require('mainConfig');

module.exports = {
    //copyrights
    'copyrightsWorld': mainConfig['endpoints.copyrightsWorld'],
    'copyrightsBounds': mainConfig['endpoints.copyrightsBounds'],
    'caption': mainConfig['endpoints.caption'],

    //search
    'geocode': mainConfig['endpoints.geocode'],
    'structuredGeocode': mainConfig['endpoints.structuredGeocode'],
    'search': mainConfig['endpoints.search'],
    'batchSearch': mainConfig['endpoints.batchSearch'],
    'batchSyncSearch': mainConfig['endpoints.batchSyncSearch'],
    'batchSearchQuery': mainConfig['endpoints.batchSearchQuery'],
    'adp': mainConfig['endpoints.adp'],
    'reverseGeocode': mainConfig['endpoints.reverseGeocode'],

    //traffic
    'trafficIncidents': mainConfig['endpoints.trafficIncidents'],
    'trafficViewport': mainConfig['endpoints.trafficViewport'],
    'flowSegmentData': mainConfig['endpoints.flowSegmentData'],
    'incidentRegions': mainConfig['endpoints.incidentRegions'],

    //layers
    'trafficLayer': mainConfig['endpoints.trafficLayer'],
    'trafficFlowLayer': mainConfig['endpoints.trafficFlowLayer'],
    'tileLayer': mainConfig['endpoints.tileLayer'],

    //routing
    'routing': mainConfig['endpoints.routing'],
    'reachableRange': mainConfig['endpoints.reachableRange'],
    'batchRoutingQuery': mainConfig['endpoints.batchRoutingQuery'],
    'batchRouting': mainConfig['endpoints.batchRouting'],
    'batchSyncRouting': mainConfig['endpoints.batchSyncRouting'],
    'matrixRouting': mainConfig['endpoints.matrixRouting'],
    'matrixSyncRouting': mainConfig['endpoints.matrixSyncRouting'],
    'batchReachableRangeQuery': mainConfig['endpoints.batchReachableRangeQuery']
};



// WEBPACK FOOTER //
// ./endpoints/endpoints.js